import { emptyAvatarPresets } from "../shared/presets/avatar.js";
import { emptyDatePickerPresets } from "../shared/presets/datePicker.js";
import { emptyFormControlPresets } from "../shared/presets/formControl.js";
import { emptyGridPresets } from "../shared/presets/grid.js";
import { emptySideSheetPresets } from "../shared/presets/sideSheet.js";
import { emptyStatusIndicatorPresets } from "../shared/presets/statusIndicator.js";
import { emptyTablePresets } from "../shared/presets/table.js";
import { autocompletePresets, badgePresets, cardPresets, circularProgressPresets, dataGridPresets, linearProgressPresets, menuPresets, stepperPresets, tooltipPresets, } from "./presets/index.js";
export const getAtlasPresets = (tokens) => {
    const presets = {
        AutocompletePresets: autocompletePresets(tokens),
        BadgePresets: badgePresets(tokens),
        CardPresets: cardPresets(tokens),
        CircularProgressPresets: circularProgressPresets(tokens),
        DataGridPresets: dataGridPresets,
        LinearProgressPresets: linearProgressPresets(tokens),
        StepperPresets: stepperPresets(tokens),
        TooltipPresets: tooltipPresets(tokens),
        MenuPresets: menuPresets(),
        // unsupported components
        AvatarPresets: emptyAvatarPresets,
        StatusIndicatorPresets: emptyStatusIndicatorPresets,
        GridPresets: emptyGridPresets,
        DatePickerPresets: emptyDatePickerPresets,
        TablePresets: emptyTablePresets,
        FormControlPresets: emptyFormControlPresets,
        SideSheetPresets: emptySideSheetPresets,
    };
    return presets;
};
//# sourceMappingURL=getAtlasPresets.js.map